<template>
  <b-container>
    <b-row>
      <b-col cols="12">
        <div class="card card-block">
          <div class="card-body p-2">
            <div class="d-flex justify-content-between align-items-start p-2">
              <b-jumbotron lead="Video de este objetivo"></b-jumbotron>
            </div>

            <b-alert show variant="info" class="p-3 text-justify">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="50"
                height="50"
                fill="currentColor"
                class="bi bi-info-circle-fill mr-2"
                viewBox="0 0 16 16"
              >
                <path
                  d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
                />
              </svg>
              Añadir un video al objetivo, ingresa la URL de Google Drive o sube
              un archivo de video directamente.
            </b-alert>

            <b-row>
              <div class="col-sm-1"></div>
              <div class="col-sm-10">
                <b-form>
                  <b-form-input
                    class="my-2"
                    ref="form_video.nombre"
                    v-model="form_video.nombre"
                    type="text"
                    placeholder="Nombre del video"
                  >
                  </b-form-input>

                  <b-form-input
                    ref="form_video.descripcion"
                    class="my-2"
                    v-model="form_video.clave"
                    type="text"
                    placeholder="Clave interna del video"
                  ></b-form-input>

                  <b-form-input
                    class="my-2"
                    ref="form_video.file_url"
                    v-model="form_video.file_url"
                    type="text"
                    placeholder="URL del Video (Google Drive o Subido)"
                    readonly
                    :disabled="publicUrl !== ''"
                  >
                  </b-form-input>

                  <b-form-input
                    class="my-2"
                    ref="form_video.file_name"
                    v-model="form_video.file_name"
                    type="text"
                    placeholder="Nombre del archivo"
                    readonly
                    v-if="false"
                  >
                  </b-form-input>

                  <div class="chunked-video-uploader">
                    <input
                      type="file"
                      @change="handleFileChange"
                      accept="video/*"
                    />
                    <b-button
                      @click="uploadFile"
                      :disabled="!selectedFile || uploading"
                    >
                      {{ uploading ? "Cargando..." : "Cargar Video" }}
                    </b-button>
                    <div v-if="uploading">
                      <p>Progreso:{{ uploadProgress.toFixed(2) }}%</p>
                      <div class="progress-bar-container">
                        <div
                          class="progress-bar"
                          :style="{ width: uploadProgress + '%' }"
                        ></div>
                      </div>
                    </div>
                    <div v-if="message" :class="messageType">{{ message }}</div>
                    <div v-if="publicUrl">
                      <p>El video ha sido cargado satifactoriamente! URL:</p>
                      <a :href="publicUrl" target="_blank">{{ publicUrl }}</a>
                    </div>
                  </div>

                  <b-row
                    class="d-flex align-items-start justify-content-start my-1"
                  >
                    <div class="w-100">
                      <b-button
                        variant="primary"
                        size="sm"
                        class="float-right"
                        @click="volver()"
                      >
                        Volver
                      </b-button>

                      <b-button
                        variant="success"
                        size="sm"
                        class="float-right mx-2"
                        @click="save()"
                      >
                        Guardar
                      </b-button>
                    </div>
                  </b-row>
                </b-form>
              </div>
              <div class="col-sm-1"></div>
            </b-row>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import toast from "../../mixins/ToastMixin";
import Bugsnag from "@bugsnag/js";
import ObjetivoVideosService from "../../services/ObjetivoVideosService";
import axios from "axios"; // Import axios for chunked uploads
import videojs from "video.js";
import "video.js/dist/video-js.css";

export default {
  name: "ObjetivosVideos",
  mixins: [toast],
  components: {
    // GDriveSelector removed
  },
  mounted() {
    this.getVideoObjetivo(this.objetivo.id);
  },
  data() {
    return {
      videos_headers: [
        { label: "Nombre", key: "nombre", class: "text-start" },

        { label: "Nombre", key: "nombre", class: "text-start" },

        { label: "Acciones", key: "actions", class: "text-center" },
      ],
      videos_items: [],
      objetivo: {
        id: this.$route.params.id,
      },
      form_video: {
        nombre: "",
        file_url: "",
        clave: "",
        descripcion: "",
        id: 0,
        editar: false,
        videoFile: null,
        file_name: "",
      },

      player: null,
      // Data properties for chunked video uploader
      selectedFile: null,
      uploading: false,
      uploadProgress: 0,
      message: "",
      messageType: "",
      publicUrl: "",
      chunkSize: 1024 * 1024 * 5, // 5MB chunks
    };
  },
  methods: {
    volver() {
      this.$router.push({
        path: `/dashboardObjetivos`,
      });
    },
    handleFileChange(event) {
      this.selectedFile = event.target.files[0];
      this.message = "";
      this.messageType = "";
      this.uploadProgress = 0;
      this.publicUrl = "";
    },
    async uploadFile() {
      if (!this.selectedFile) {
        this.message = "Selecciona un archivo por favor.";
        this.messageType = "error";
        return;
      }

      this.uploading = true;
      this.message = "Iniciando carga ...";
      this.messageType = "info";
      this.uploadProgress = 0;
      this.publicUrl = "";

      // Configure axios to send cookies with requests
      axios.defaults.withCredentials = true;
      const API_URL = process.env.VUE_APP_API_URL;

      // Fetch CSRF cookie
      try {
        await axios.get(`${API_URL}/sanctum/csrf-cookie`);
      } catch (error) {
        console.error("CSRF cookie fetch error:", error);
        this.message = `Failed to fetch CSRF token: ${error.message}`;
        this.messageType = "error";
        this.uploading = false;
        return;
      }

      const totalChunks = Math.ceil(this.selectedFile.size / this.chunkSize);
      let uploadedChunks = 0;
      let uploadSuccessful = false; // Flag to track overall upload success

      for (let i = 0; i < totalChunks; i++) {
        const start = i * this.chunkSize;
        const end = Math.min(start + this.chunkSize, this.selectedFile.size);
        const chunk = this.selectedFile.slice(start, end);

        const formData = new FormData();
        formData.append("file", chunk);
        formData.append("fileName", this.selectedFile.name);
        formData.append("chunkIndex", i);
        formData.append("totalChunks", totalChunks);
        formData.append("fileSize", this.selectedFile.size);
        formData.append("fileType", this.selectedFile.type);

        try {
          const response = await axios.post(
            `${API_URL}/api/video-upload/chunk`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                // Add authorization header if your API requires it (e.g., Bearer token)
                // 'Authorization': `Bearer YOUR_AUTH_TOKEN`
              },
              onUploadProgress: (progressEvent) => {
                const chunkProgress =
                  (progressEvent.loaded / progressEvent.total) *
                  (100 / totalChunks);
                this.uploadProgress =
                  (uploadedChunks * 100) / totalChunks + chunkProgress;
              },
            }
          );

          if (response.data.message === "Chunk recivido") {
            uploadedChunks++;
            this.message = `Cargando chunk ${i + 1} de ${totalChunks}...`;
          } else if (response.data.message === "File uploaded successfully") {
            uploadSuccessful = true;
            this.publicUrl = response.data.publicUrl;
            this.uploadProgress = 100;
            this.form_video.file_url = this.publicUrl;
            this.form_video.file_name = this.selectedFile.name;
          }
        } catch (error) {
          console.error("Upload error:", error);
          let errorMessage = error.response?.data?.message || error.message;
          if (error.response?.data?.errors) {
            errorMessage +=
              "\n" +
              Object.values(error.response.data.errors).flat().join("\n");
          }
          this.message = `Upload failed: ${errorMessage}`;
          this.messageType = "error";
          this.uploading = false;
          this.uploadProgress = (uploadedChunks * 100) / totalChunks;
          return;
        }
      }

      this.uploading = false;
      if (uploadSuccessful) {
        this.message = "Carga del archivo de video Completa!";
        this.messageType = "success";
      }
    },
    async getVideoObjetivo(objetivo_id) {
      try {
        let response = await ObjetivoVideosService.get(objetivo_id);
        let { message, file_url, color, success, resultSet } = response.data;

        if (success && resultSet) {
          if (file_url && file_url.startsWith("#")) {
            this.form_video.file_url = `https://storage.googleapis.com/jalisco-aprende/videos/${resultSet.file_name}.mp4`;
          } else {
            this.form_video.file_url = file_url;
          }
          this.form_video.nombre = resultSet.nombre;
          this.form_video.clave = resultSet.clave;
          this.form_video.file_name = resultSet.file_name;
        }

        this.toast("b-toaster-bottom-center", true, message, color);
      } catch (error) {
        this.toast(
          "b-toaster-bottom-center",
          true,
          "Ocurrió un error, favor de comunicarse con su administrador 🙏 ",
          "danger"
        );
        Bugsnag.notify(
          new Error("Método: getVideoObjetivo() " + error.message)
        );
      }
    },

    async save() {
      this.toast(
        "b-toaster-bottom-center",
        true,
        "Guardando información del video...",
        "info"
      );
      let formData = new FormData();

      // Use the publicUrl from the direct upload if available, otherwise use form_video.file_url
      const finalFileUrl = this.publicUrl || this.form_video.file_url;
      if (!finalFileUrl) {
        this.toast(
          "b-toaster-bottom-center",
          true,
          "Por favor, sube un video o ingresa una URL.",
          "danger"
        );
        return;
      }

      formData.append("file_url", finalFileUrl);
      formData.append("objetivo_id", this.objetivo.id);
      formData.append("nombre", this.form_video.nombre);
      formData.append("clave", this.form_video.clave);
      formData.append("file_name", this.form_video.file_name);

      try {
        const response = await ObjetivoVideosService.save(formData);
        let { success, message, color } = response.data;

        if (success) {
          this.form_video.file_url = "";
          this.form_video.nombre = "";
          this.form_video.clave = "";
          // Reset publicUrl after successful save
          this.publicUrl = "";

          this.toast("b-toaster-bottom-center", true, message, color);
        }
        await this.getVideoObjetivo(this.objetivo.id);
      } catch (error) {
        this.toast(
          "b-toaster-bottom-center",
          true,
          "Ocurrió un error, favor de comunicarse con su administrador: " +
            error.message,
          "danger"
        );
        Bugsnag.notify(new Error("Método: save() " + error));
      }
      this.volver();
    },
    delete() {}, // No longer used

    loadVideoPlayer() {
      this.player = videojs(this.$refs.videoPlayer);
      this.showCurrentVideo = true;
    },
  },
};
</script>

<style lang="scss" scoped>
$studioAPPColor: #ff8250;

.btn-studioAPP {
  color: $studioAPPColor !important;
  border: 1px solid $studioAPPColor;
}

.btn-studioAPP:hover,
.btn-studioAPP:active {
  background-color: $studioAPPColor !important;
  color: white !important;
}

.hide-video {
  display: none;
}

/* Styles for chunked video uploader */
.chunked-video-uploader {
  font-family: Arial, sans-serif;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
  max-width: 600px;
  margin: 20px auto;
  background-color: #f9f9f9;
}

.chunked-video-uploader h2 {
  color: #333;
  margin-bottom: 20px;
}

.chunked-video-uploader input[type="file"] {
  display: block;
  margin-bottom: 15px;
}

.chunked-video-uploader button {
  background-color: #007bff;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
}

.chunked-video-uploader button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.progress-bar-container {
  width: 100%;
  background-color: #e0e0e0;
  border-radius: 5px;
  margin-top: 10px;
  height: 20px;
  overflow: hidden;
}

.progress-bar {
  height: 100%;
  background-color: #28a745;
  width: 0%;
  border-radius: 5px;
  text-align: center;
  color: white;
  line-height: 20px;
  transition: width 0.3s ease-in-out;
}

.message {
  margin-top: 15px;
  padding: 10px;
  border-radius: 5px;
}

.info {
  background-color: #e7f3fe;
  color: #0056b3;
  border: 1px solid #b8daff;
}

.success {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.error {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.chunked-video-uploader a {
  color: #007bff;
  text-decoration: none;
}

.chunked-video-uploader a:hover {
  text-decoration: underline;
}
</style>
